module.exports = __webpack_public_path__ + "static/media/Hot Dog Man.033e8675.jpg";